import { Injectable } from '@angular/core';
import { NetworkHelper, WmPoolErrorResponse } from '@wm-libs/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@wm-libs/core';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  readonly apiUrl = `${environment.poolApi}/support`;

  constructor(private networkHelper: NetworkHelper) {}

  sendEmail(email: string, message: string): Observable<ApiResponse | WmPoolErrorResponse> {
    return this.networkHelper.post<ApiResponse | WmPoolErrorResponse>(`${this.apiUrl}/contact-us`, { email, message });
  }
}
